export default __webpack_public_path__ + "static/team09-8dbb153eeb378a2689967c3204101e04.webp";